const handlers = {
    tokenReceivedHandler: undefined
};

const tokenReceived = (token, backendUrl) => {
    if (handlers.tokenReceivedHandler) {
        handlers.tokenReceivedHandler({token, backendUrl});
    }
}

const productUpdate = (productSetup) => {
    // alert("Host zmienił ustawienia produktu " + JSON.stringify(productSetup));
};

const templateFormatSet = (templateFormatId) => {
    // alert("Host zmienił template format " + templateFormatId);
};

const messenger = new K2PEditorMessenger({tokenReceived, productUpdate, templateFormatSet});

export { 
    messenger, 
    handlers 
};



